import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://infinity-gainers.onrender.com',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Rutas públicas (permitidas sin token)
const publicRoutes = [
  "^/products$",
  "^/products\\?.*",
  "^/products/\\d+",
  "^/products/images.*",
  "^/categories.*",
  "^/companies$",
  "^/events.*",
];

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");

  console.log("📡 URL solicitada:", config.url);

  // Usamos regex para detectar si es pública
  const isPublic = publicRoutes.some(routePattern => {
    const regex = new RegExp(routePattern);
    return config.url && regex.test(config.url);
  });

  console.log("🛡️ Ruta pública:", isPublic);

  if (token && !isPublic) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log("🔐 Token agregado para:", config.url);
  }

  return config;
});

//  Interceptor de respuesta para manejar errores como token vencido
instance.interceptors.response.use(
  response => response,
  error => {
    const isAuthError = error.response && error.response.status === 401;
    const isLoginAttempt = error.config?.url?.includes("/users/login");

    if (isAuthError && !isLoginAttempt) {
      console.warn("⚠️ Token vencido o inválido. Se cerrará la sesión.");
      localStorage.removeItem("access_token");
      alert("Tu sesión ha expirado. Por favor, iniciá sesión nuevamente.");
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);


export default instance;
